const apis = {
	getConfig: "Common/getConfig",
	getCaipiaoHall: "Caipiao/getCaipiaoHall",
	getCategoryList: "Caipiao/getCategoryList",
	getCaipiaoList: "Caipiao/getCaipiaoList",
	getCaipiaoLhc: "Caipiao/getCaipiaoLhc",
	flushDraw: "Caipiao/flushDraw",
	getCaipiaoDetail: "Caipiao/getCaipiaoDetail",
	getCaipiaoHistory: "Caipiao/getCaipiaoHistory",

	getCaipiaoChanglong: "Caipiao/getCaipiaoChanglong",
	upload: "Common/upload",
	feedback: "Common/feedback",

	getRichtextList: "Common/getRichtextList",
	getRichtextInfo: "Common/getRichtextInfo",
};

const baseURL = process.env.VUE_APP_BASE_API

Object.keys(apis).forEach((key) => {
	// 	if (process.env.NODE_ENV === "development") {
	// 		apis[key] = `https://kj.frnn-vip2666.com/api/${apis[key]}`
	// 	} 
	apis[key] = `${baseURL}/api/${apis[key]}`
});

export default apis;